import { authFetch } from "../utils/AuthFetch";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';
const token = localStorage.getItem('user_token');

export interface Reservation {
  id: number;
  space: {
    id: number;
    name: string;
    title: string;
    owner: {
      id: number;
      email: string;
      nickname: string;
      phone_number?: string;
    };
  };
  depositor: {
    id: number;
    nickname: string;
  };
  main_image?: string;
  start_date: string;
  end_date: string | null;
  comment: string | null;
  status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'PAYMENT_COMPLETED' | 'STORED' | 'RETURNED' | 'CANCELED' | 'FINISHED';
  total_price: number | null;
  additional_charge: number | null;
  escrow_payment_id: number | null;
  created_at: string;
  updated_at: string;
  order_id: string;
}

export async function createReservation(formData: FormData) {
  const token = localStorage.getItem('user_token');

  const res = await authFetch(`${API_BASE_URL}/reservation/reservations`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData
    })
  
  if (!res.ok) {
    const error = await res.text();
    throw new Error(error || 'Failed to create reservation');
  }

  return await res.json();
}

  export const getReservations = async () => {
    const token = localStorage.getItem('user_token');
    const response = await fetch(`${API_BASE_URL}/reservation/reservations`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  
    if (!response.ok) {
      throw new Error('Failed to fetch reservations');
    }
  
    return response.json();
  };

  export const getAdminReservations = async (page = 1, limit = 10) => {
    const token = localStorage.getItem('user_token');
    const response = await fetch(
      `${API_BASE_URL}/reservation/admin/reservations?page=${page}&limit=${limit}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
  
    if (!response.ok) {
      throw new Error('Failed to fetch reservations');
    }
  
    return response.json();
  };

  export const getUserReservations = async (): Promise<Reservation[]> => {
    const response = await authFetch(`${API_BASE_URL}/reservation/user/reservations`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch reservations');
    }
  
    return response.json();
  };

  export const fetchReservationData = async (reservationId: number, dto: any) => {
    const token = localStorage.getItem('user_token');
    if (!token) {
      throw new Error('Token is missing. Please login.');
    }
  
    const formData = new FormData();
  
    // DTO 객체의 'status' 항목은 무조건 추가
    formData.append('status', dto.status);
  
    // 'stored_image'가 있을 경우에만 추가
    if (dto.stored_image && dto.stored_image.length > 0) {
      formData.append('stored_image', dto.stored_image[0]);
    }
  
    try {
      const response = await authFetch(`${API_BASE_URL}/reservation/reservations/${reservationId}`, {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${token}`, // Authorization 헤더에 토큰 추가
        },
        body: formData,
      });
  
      if (!response.ok) {
        throw new Error('Failed to update reservation.');
      }
  
      return await response.json();
    } catch (error) {
      console.error('Error during fetch:', error);
      throw error;
    }
  };

  
  /**
   * Approve a specific reservation.
   * @param reservationId - ID of the reservation to approve
   */
  export const approveReservation = async (reservationId: number) => {
    const response = await authFetch(`${API_BASE_URL}/reservation/reservations/${reservationId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ status: 'APPROVED' }),
    });
  
    if (!response.ok) {
      throw new Error('Failed to approve reservation');
    }
  
    return response.json();
  };

  export const rejectReservation = async (reservationId: number) => {
    const response = await authFetch(`${API_BASE_URL}/reservation/reservations/${reservationId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json', Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ status: 'REJECTED' }),
    });
  
    if (!response.ok) {
      throw new Error('Failed to reject reservation');
    }
  
    return response.json();
  }

  export const getReservationById = async (id: number) => {
    const token = localStorage.getItem('user_token');
    const response = await fetch(`${API_BASE_URL}/reservation/reservations/${id}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  
    if (!response.ok) {
      throw new Error('Failed to fetch reservation');
    }
 
    return response.json();
  };

  export const getReservationBySpaceId = async (spaceId: number) => {
    const token = localStorage.getItem('user_token');
    const response = await fetch(`${API_BASE_URL}/reservation/space/reservations/${spaceId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  
    if (!response.ok) {
      throw new Error('Failed to fetch reservation');
    }
 
    return response.json();
  };